import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import type { PanDirection, PanMethod } from '~/components2/ZoomableImage';

interface FieldNotePhotoAnalyticsContext {
  projectId: string | null;
  organizationId?: string | null;
  noteId: string;
}

/** Fires when the photo actually enters or leaves fullscreen (covers Esc; skips a failed request). */
export function captureFieldNotePhotoFullscreenToggled(
  ctx: FieldNotePhotoAnalyticsContext,
  isFullscreen: boolean,
): void {
  if (!ctx.projectId) return;
  captureTypedPosthogEvent(POSTHOG_EVENTS.projectFieldNotePhotoFullscreenToggled, {
    project_id: ctx.projectId,
    organization_id: ctx.organizationId || undefined,
    note_id: ctx.noteId,
    action: isFullscreen ? 'entered' : 'exited',
  });
}

/** Fires for overlay zoom-in / zoom-out button clicks, not wheel or double-click reset. */
export function captureFieldNotePhotoZoomed(ctx: FieldNotePhotoAnalyticsContext, direction: 1 | -1): void {
  if (!ctx.projectId) return;
  captureTypedPosthogEvent(POSTHOG_EVENTS.projectFieldNotePhotoZoomed, {
    project_id: ctx.projectId,
    organization_id: ctx.organizationId || undefined,
    note_id: ctx.noteId,
    direction: direction === 1 ? 'in' : 'out',
  });
}

/** Fires for each overlay pan button press or arrow-key pan step, not drag panning. */
export function captureFieldNotePhotoPanned(
  ctx: FieldNotePhotoAnalyticsContext,
  direction: PanDirection,
  method: PanMethod,
): void {
  if (!ctx.projectId) return;
  captureTypedPosthogEvent(POSTHOG_EVENTS.projectFieldNotePhotoPanned, {
    project_id: ctx.projectId,
    organization_id: ctx.organizationId || undefined,
    note_id: ctx.noteId,
    direction,
    method,
  });
}
